import './WhatAreYouLookingFor.css';
import stopEventPropagation from '../ui_core/stopEventPropagation';
import PropertyBindingFactory from '../mvvm/PropertyBindingFactory';
import numberWithCommas from '../core/numberWithCommas';
import Feature from '../enums/Feature';
export default class WhatAreYouLookingForToggleButton{
	constructor({callbackClicked, text, value}){
		this._value = value;
		this._callbackClicked = callbackClicked;
		this._clicked = this._clicked.bind(this);
		this.select = this.select.bind(this);
		this.unselect = this.unselect.bind(this);
		this._selected = false;
		this._element = document.createElement('button');
		this._element.classList.add('child-option-button');
		this._element.innerHTML = text;
		this._element.addEventListener('click', this._clicked);
		stopEventPropagation(this._element, ['click', 'mousedown', 'touchstart']);
	}
	setAvailableOption(value){
		if(value)
			this._element.classList.remove('not-available-option');
		else 
			this._element.classList.add('not-available-option');
	}
	get selected(){
		return this._selected;
	}
	get value(){
		return this._value;
	}
	_clicked(){
		this._callbackClicked(this);
	}
	select(){
		this._selected = true;
		this._element.classList.add('selected');
	}
	unselect(){
		this._selected = false;
		this._element.classList.remove('selected');
	}
	get element(){
		return this._element;
	}
}